/**
*  Content Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the  Content Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-accordion__title' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
      } );

      $( '.content-accordion__content' ).each( function( index ) {
        if ( index === 1 ) {
          $( this ).addClass( 'xl:ml-auto' );
        }
      } );

      let maxHeight = -1;

      $( '.content-accordion__header' ).each( function() {
        maxHeight = maxHeight > $( this ).height() ? maxHeight : $( this ).height();
      } );

      $( '.content-accordion__header' ).each( function() {
        $( this ).height( maxHeight );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-accordion', COMPONENT );
} )( app );
